import { z } from 'zod';

// The endpoint applies the same rules server-side.
export const editAddressSchema = z.object({
    addressLine1: z
        .string()
        .min(1, 'Required')
        .regex(/^[a-zA-Z0-9\s.,\-/#']*$/, 'No symbols allowed in the address field.'),
    city: z.string().min(1, 'Required'),
    state: z.string().min(1, 'Required'),
    postalCode: z.string().min(1, 'Required').regex(/^[0-9]{5}$/, 'Use 5 digit postal'),
});
